import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';

export interface BookingUrlDialogData {
  bookingUrl: string;
  meetingId: string;
}

@Component({
  selector: 'meeting-scheduler-booking-url-dialog',
  templateUrl: './booking-url-dialog.component.html',
  styleUrls: ['./booking-url-dialog.component.scss'],
  standalone: false,
})
export class BookingUrlDialogComponent {
  copied = false;

  constructor(
    private readonly ref: MatDialogRef<BookingUrlDialogComponent>,
    @Inject(MAT_DIALOG_DATA) readonly data: BookingUrlDialogData,
    private readonly clipboard: Clipboard,
  ) {}

  onClose(): void {
    this.ref.close();
    // Navigate back to the previous page (meeting list)
    window.history.back();
  }

  onCopyUrl(): void {
    const success = this.clipboard.copy(this.data.bookingUrl);
    if (success) {
      this.copied = true;
      // Reset the copied state after 2 seconds
      setTimeout(() => {
        this.copied = false;
      }, 2000);
    }
  }
}
